import '../../css/Unauthorized.css'
import { Row, Col, Typography, Button, Space } from "antd";
import { useParams, useNavigate, useLocation} from 'react-router-dom';
import queryString from 'query-string';
import { loadConfig } from 'utils/config';

// import { apiLogout } from "apis/authentication.api";
// import Cookies from 'js-cookie'

const { Title, Text } = Typography;

export const Unauthorized = () =>{
    let navigate = useNavigate();
    const location = useLocation();
    const { appId } = useParams();
    const params = queryString.parse(location.search);
    const logout = async () => {
        const config = await loadConfig();
        window.location.href = `${config.AUTHEN_API}/logout/${params.service}/${appId}`;
    }

    return(
        <>
        <Row 
            justify="space-around"
            align="middle"
            style={{
            height: '100vh'
            }}
        >
            <Col>
                <div className='card'>
                    <Space direction="vertical" style={{
                        position: 'absolute',
                        bottom: '15%',
                        left: '13%',
                        right: '13%',
                    }}>
                    <Title level={5}>No authorization found</Title>
                    <div style={{
                        textAlign: 'center'
                    }}>
                        <Text >
                            This page is not publically available.To access it please login first.
                        </Text>
                    </div>
                    <Text type="danger">User doesn't exist in {params.app} please contact administrator</Text>
                    <Button onClick={()=>{logout()}} style={{
                        width: '50%',
                        backgroundColor: '#63CABD',
                        color: 'white',
                        marginTop: '10px'
                    }}>Return Home</Button>
                    </Space>
                </div>
            </Col>
        </Row>
        </>
    )
}